import React from 'react';
import './ProjectTableLoader.css';

/** Renders the teal ring; use with `Spin` `indicator` for non-table full-page areas. */
export const PROJECT_TABLE_LOADER_INDICATOR = (
  <span className="project-table-loader-dot" role="status" aria-label="Loading" />
);

/**
 * antd `Table` `loading` object: centered teal ring, full-width overlay.
 * @param {boolean} spinning
 */
export function getProjectTableLoadingConfig(spinning) {
  return {
    spinning,
    wrapperClassName: 'project-dashboard-table-spin',
    indicator: PROJECT_TABLE_LOADER_INDICATOR,
  };
}
